declare var config: any; //the .js file

export class Config { // small class to make the bridge between the .js file and the rest

  static isProd = config.prod;
  static serverUrl = config.prod ? config.prod_api_url : config.dev_api_url;
  static imageServerUrl = config.image_server_url;
  static websiteHealthServerUrl = config.website_health_server_url;
  static useIvan = config.use_ivan;
  static frontendUrl = config.frontend_url;
  static studios = config.studios;
  static showAmazonUS = config.show_amazon_us || false;
  static activateReferrals = config.activate_referrals;
  static showAds = config.show_ads;
  static fbAppId = config.fb_app_id;
  static privacyPolicyDE: string = config.privacy_policy_de;
  static privacyPolicyEN: string = config.privacy_policy_en;
}
